import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';

@Component({
  name: 'ButtonPhoto',
})
export default class ButtonPhoto extends Vue {
  @Prop({type: String, default: ''}) public readonly name;
  @Prop({type: Number, default: 0}) public readonly count;

  private render(createElement: CreateElement): VNode {
    return createElement('button', {
      class: ['button-photo', 'p3'],
    }, `${this.name} (${this.count})`);
  }
}
